export const aiIcon = 'material-symbols:auto-awesome';
export const partyIcon = 'noto:party-popper';
export const linkedInIcon = 'mdi:linkedin';
export const newWindowIcon = 'fluent:window-new-16-regular';
